import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

/**
 * Conversion banner for the high-SEO auctioneer directory pages. The visitors
 * there are overwhelmingly nonprofits/event hosts shopping for an auctioneer —
 * i.e. CharityFundraiser's actual buyers — so we surface a "run your whole
 * event with us" CTA. Existing auctioneer-facing CTAs (claim/feature listing)
 * stay intact; this targets the other side of the marketplace.
 *
 * Props:
 *   context  optional location phrase, e.g. "in Austin, TX" or "in Texas"
 */
export const NonprofitAuctionCTA = ({ context = "" }) => (
    <section className="max-w-5xl mx-auto px-6 my-12" data-testid="nonprofit-auction-cta">
        <div className="relative overflow-hidden bg-primary text-primary-foreground border border-primary/40 shadow-lg px-8 py-10 sm:px-12 sm:py-12">
            <div className="absolute -right-12 -top-12 w-52 h-52 rounded-full bg-accent/15 blur-3xl pointer-events-none" />
            <div className="relative max-w-2xl">
                <p className="label-eyebrow text-accent">For nonprofits &amp; event hosts</p>
                <h2 className="font-heading text-3xl sm:text-4xl mt-2 leading-tight">
                    Running a benefit auction{context ? ` ${context}` : ""}?
                </h2>
                <p className="text-white/80 text-sm sm:text-base mt-3 leading-relaxed">
                    Plan, promote, and run your entire event with CharityFundraiser — mobile bidding,
                    live paddle-raise &amp; fund-a-need, on-site checkout, instant tax receipts, and a
                    built-in donor CRM. Free to start; pay only on what you raise.
                </p>
                <div className="flex flex-wrap items-center gap-5 mt-6">
                    <Link
                        to="/signup-org"
                        data-testid="cta-signup-org"
                        className="inline-flex items-center gap-2 bg-accent text-accent-foreground px-7 py-3.5 text-xs uppercase tracking-[0.2em] font-bold hover:opacity-90 transition-opacity"
                    >
                        Start free <ArrowRight size={14} weight="bold" />
                    </Link>
                    <Link
                        to="/features"
                        data-testid="cta-see-how"
                        className="text-xs uppercase tracking-[0.2em] font-bold text-white/85 hover:text-white underline underline-offset-4"
                    >
                        See how it works
                    </Link>
                </div>
            </div>
        </div>
    </section>
);

export default NonprofitAuctionCTA;
